/**
 * Office-name (property) autocomplete rows appear on home, search, area, and
 * location pages — not campaign, entity, or other marketing routes.
 */

const ENTITY_OR_MARKETING_SEGMENTS = new Set([
  "properties",
  "property",
  "workspaces",
  "workspace",
  "buildings",
  "listings",
  "blog",
  "news",
  "office-spaces",
  "find-perfect-workspace",
  "contact",
  "contact-us",
  "about",
  "about-us",
  "list-with-us",
  "add-listing",
  "compare",
  "favorites",
  "space-type",
  "partners",
  "pricing",
]);

export function shouldShowAutoPlacesOfficeNames(pathname: string): boolean {
  const segments = pathname.replace(/\/+$/, "").split("/").filter(Boolean);
  const first = segments[0]?.toLowerCase();
  const second = segments[1]?.toLowerCase();

  // Home: `/` or `/{country}`
  if (segments.length === 0) return true;
  if (segments.length === 1 && first && !ENTITY_OR_MARKETING_SEGMENTS.has(first)) {
    return true;
  }

  // /search or /{country}/search/...
  if (first === "search" || second === "search") return true;

  // /areas/... or /{country}/areas/...
  if (first === "areas" || second === "areas") return true;

  // Location geosearch: /{country}/{state}/... (not marketing/entity routes)
  if (segments.length >= 2 && second && !ENTITY_OR_MARKETING_SEGMENTS.has(second)) {
    return true;
  }

  return false;
}
